import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import { useAtom } from 'jotai';

import { isLayoutMobileAtom } from '@/store/layout';

import useStyles from './ActivityLog.styles';
import type {
  ActivityLogRuleProps,
  ActivityLogTicketProps
} from './ActivityLog.types';

const ActivityLog = (props: ActivityLogRuleProps | ActivityLogTicketProps) => {
  const { activities } = props;
  const [isLayoutMobile] = useAtom(isLayoutMobileAtom);
  const { classes } = useStyles({ isLayoutMobile });

  return (
    <List className={classes.activityLogList}>
      {activities?.map((event) => {
        return (
          <ListItem key={event.id} className={classes.activityLogListItem}>
            <ListItemAvatar className={classes.activityLogListItemAvatar}>
              <Avatar className={classes.activityLogAvatar} alt={event.message}>
                {event.icon}
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              className={classes.activityLogListItemText}
              primary={event.message}
              secondary={`by ${event.user.name}, ${event.created_at}`}
            />
          </ListItem>
        );
      })}
    </List>
  );
};

export default ActivityLog;
